import DC from "../../../common/DataConnector";
import { i18n } from '../../../lang/i18n';
import CheckboxSwitch from '../../../components/CheckboxSwitchComponent/CheckboxSwitch'
import BackArrow from "../../../components/BackArrowComponent/BackArrow";
import ContactInfoComponent from "../ContactInfoComponent";
import ScrollToTop from "../../../components/ScrollToTop";
import { reducerUserLoad } from "../../../store/UserData/UserDataReducer";
import { actLoading, actLoadingEnd } from "../../../store/Actions";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";

export default function UserSettings() {
    const dispatch = useAppDispatch()
    const userData = useAppSelector((state) => state.userData)
    async function onPreferenceChange(e: any, ck: any) {
        e.preventDefault();
        actLoading(dispatch)
        const obj: any = userData.preferences
        obj[ck.field] = ck.active
        const postData: any = {};
        postData[ck.field] = ck.active;
        const result = await DC.Patch('/customer/preferences', postData);
        if (result.wasOk) {
            dispatch(reducerUserLoad({ preferences: obj }))
        }
        actLoadingEnd(dispatch)
        return true;
    }

    return (<div className="users">
        <ScrollToTop />
        <div className="main-subtitle">
            <h3>{i18n.TabUser.MenuPreferences}</h3>
        </div>
        <div className="card-body">
            <div className="container">
                <ContactInfoComponent />
                <div className="form-group row mt-5">
                    <label className="col-sm-8 col-form-label">{i18n.Customer.PreferencesReceivePromotions}</label>
                    <div className="col-sm-4">
                        <CheckboxSwitch conf={{
                            fieldName: 'receivePromotions',
                            textActive: i18n._Labels.Yes,
                            textDeactivate: i18n._Labels.No,
                            active: userData.preferences.receivePromotions
                        }} onChangeAsync={onPreferenceChange} />
                    </div>
                </div>
                <div className="form-group row">
                    <label className="col-sm-8 col-form-label">{i18n.Customer.PreferencesReceiveNews}</label>
                    <div className="col-sm-4">
                        <CheckboxSwitch conf={{
                            fieldName: 'receiveNews',
                            textActive: i18n._Labels.Yes,
                            textDeactivate: i18n._Labels.No,
                            active: userData.preferences.receiveNews
                        }} onChangeAsync={onPreferenceChange} />
                    </div>
                </div>
            </div>
        </div>
        <BackArrow path="/user" />
    </div>)
}